import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';
import { AuthAnimation } from './AuthAnimation';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string | string[];
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user, hasRole } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }

    if (!isLoading && isAuthenticated && requiredRole && !hasRole(requiredRole)) {
      navigate('/unauthorized', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, requiredRole, hasRole, user]);

  if (isLoading) {
    return (
      <AuthAnimation 
        isOpen={true} 
        type="loading" 
      />
    );
  }

  if (requiredRole && !hasRole(requiredRole)) {
    return null;
  }

  return isAuthenticated ? <>{children}</> : null;
}